module.exports = __webpack_public_path__ + "static/media/fbinstall.781bb4bb.webp";